const trackingKey = "uHLYlNVwIo6Bi0Puok1Z39NA2hjUUnwQLh6Tftn4"; //not for security, instead it is used for metrics, performance and debugging.

async function getCountryAcceptance() {
  return await fetch(
    "https://0wgjxu6jh2.execute-api.us-west-2.amazonaws.com/api/country-acceptance/v2/coverage?pagesize=100000&card_network=DN",
    {
      method: "GET",
      headers: {
        "x-api-key": trackingKey,
        Accept: "application/json",
      },
    }
  );
}

export async function getCountries() {
  return await fetch(
    "https://0wgjxu6jh2.execute-api.us-west-2.amazonaws.com/api/country-acceptance/v2/countries?pagesize=100000&card_network=DN",
    {
      method: "GET",
      headers: {
        "x-api-key": trackingKey,
        Accept: "application/json",
      },
    }
  );
}

export default getCountryAcceptance;
